$(document).ready(function() {
    /* 9 ---------------------------------------------------------------------------------------- */

    if ($('#gadget-section-9').length) {
        let owl_9 = $("#gadget-section-9 .owl-carousel").owlCarousel({
            items: 1,
            nav: false,
            dots: true,
            loop: false,
            margin: 20,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2
                }
            }
        });
    }
    
});

$(window).scroll(function () {

    /* 2 ------------------------------------------------------------------------------- */

    if ($('#gadget-section-2').length) {
        $section2 = $('#gadget-section-2');
        if(calculateScrollPercentage($section2) >= 10){
            if (!$section2.find('.aos-init').hasClass('aos-animate'))
                $section2.find('.aos-init').addClass('aos-animate');
        }
        else {
            if ($section2.find('.aos-init').hasClass('aos-animate'))
                $section2.find('.aos-init').removeClass('aos-animate');
        }
    }

    /* 3 ------------------------------------------------------------------------------- */

    if ($('#gadget-section-3').length) {
        $section3 = $('#gadget-section-3');
        if (visiblePercent($section3) > 40) {
            if (!$section3.find('.image-container').hasClass('aos-animate'))
                $section3.find('.image-container').addClass('aos-animate');

            setTimeout(() => {
                $section3.find('.section-image').css('top', '0');
                $section3.find('.section-image').css('filter', 'drop-shadow(0px 0px 30px #0047AB)');
                $section3.find('.texts').addClass('aos-animate');
            }, 1000);
        }
        else {
            if ($section3.find('.image-container').hasClass('aos-animate'))
                $section3.find('.image-container').removeClass('aos-animate');

            setTimeout(() => {
                $section3.find('.section-image').css('top', '80px');
                $section3.find('.section-image').css('filter', 'unset');
                $section3.find('.texts').removeClass('aos-animate');
            }, 1000);
        }
    }

    /* 4 ---------------------------------------------------------------------------- */

    if ($('#gadget-section-4 ').length) {
        $section4_1 = $('#gadget-section-4 .clip-anchor');
        $section4_2 = $('#gadget-section-4 .viewport-anchor');

        let path4 = 20;
        if (wSize >= 1280)
            path4 = (visiblePercent($section4_1)/10) + (visiblePercent($section4_2)/10);

        $('#gadget-section-4 .clip').css('clip-path', `polygon(${20-path4}% 0, ${80+path4}% 0, ${80+path4}% 100%, ${20-path4}% 100%)`);

        $video4 = $('#gadget-section-4 .video-bg .container');
        if (isInFull($video4) == 'full') {
            $('#gadget-section-4 .video-bg .absVideo').css({
                'position': 'fixed',
                'top': '0',
                'bottom': 'unset'
            });
        }
        else if (isInFull($video4) == 'partial-bottom') {
            $('#gadget-section-4 .video-bg .absVideo').css({
                'position': 'absolute',
                'top': '0',
                'bottom': 'unset'
            });
        }
        else {
            $('#gadget-section-4 .video-bg .absVideo').css({
                'position': 'absolute',
                'top': 'unset',
                'bottom': '0'
            });
        }
    }

    /* 5 ---------------------------------------------------------------------------- */

    if ($('#gadget-section-5').length) {
        $('#gadget-section-5 .aos-init').each(function() {
            if (isElementInView($(this))) {
                $(this).addClass('aos-animate');
            }
            else {
                $(this).removeClass('aos-animate');
            }
        });
    }

});

$('#gadget-section-7 .toggle-player').on('click', function() {
    let video = $('#gadget-section-7 #thisVideo')[0];

    if (video.paused) {
        video.play();
        $('#gadget-section-7 .toggle-player .pause').addClass('active');
        $('#gadget-section-7 .toggle-player .play').removeClass('active');
    } 
    else {
        video.pause();
        $('#gadget-section-7 .toggle-player .pause').removeClass('active');
        $('#gadget-section-7 .toggle-player .play').addClass('active');
    }
});